import React from 'react';
import Property from '../pagehandler/utils/frp.js';

export function listenValue(Component, ...names) {
	class Listener extends React.Component {
		constructor(props) {
			super(props);
			this.state = {};
			this.listeners = {};
			for (const name of names) {
				this.listeners[name] = value => this.setState({[name]: value});
			}
		}
		componentWillMount() {
			this.componentWillReceiveProps(this.props);
		}
		componentWillReceiveProps(props) {
			for (const name of names) {
				if (this.props[name]) {
					this.props[name].off(this.listeners[name]);
				}
				props[name].on(this.listeners[name]);
			}
		}
		componentWillUnmount() {
			for (const name of names) {
				this.props[name].off(this.listeners[name]);
			}
		}
		render() {
			return React.createElement(Component, Object.assign({}, this.props, this.state));
		}
	}

	const componentName = Component.displayName || Component.name || '<anonymous>';
	Listener.displayName = `ListenValue(${componentName})`;

	return Listener;
}

export const Value = Property.new;

export default listenValue;



// WEBPACK FOOTER //
// ./lib/components/value.js